import { doGetRequest } from './axios_';
import {Utils} from './utils'

// 查询运营平台对商户属性设置开关状态
export const requestOrgPropertySetting = async () => {
  const data = await doGetRequest({
    url: `/openapi/dic/ref/getDicRefInfoForOrgOfMap?thirdPartyId=${Utils.getOrgId()}`,
    noRespStatus: true,
    noToken: true
  }).catch(() => {})
  const { code = '' } = data || {};
  if (code === 10000) {
    const { data: properties = {} } = data;
    return Promise.resolve(properties)
  }else {
    return Promise.resolve({})
  }
}

/**
 * 是否开通多级产品配置
 * @returns true:开通
 */
export const isOpenMultiLevelProduct = async() => {
  const properties = await requestOrgPropertySetting()
  return Promise.resolve(properties['openMultiLevelProduct'] || false);
}
/**
 * 是否展示平台产品的详细来源？
 * @returns true:展示
 */
export const isShowProductDetailSource = async() => {
  const properties = await requestOrgPropertySetting()
  return Promise.resolve(properties['isShowProductDetailSource'] || false);
}

/**
 * 获取某个商户属性配置开关状态
 * @param {*} property
 * @returns true:开通
 */
export const getProperty = async(property = '') => {
  if (!property || typeof property !== 'string') return false;
  const properties = await requestOrgPropertySetting();
  return Promise.resolve(properties[property] || false);
}
// 获取对公对私属性. 1-对公 2-对私
export const getPublicOrPrivate = async () => {
  const res = await doGetRequest({
    url: `/api/srm/org/settlement/rule/read/info`,
  }).catch(() => {
    return Promise.resolve('')
  }) || {};
  const {paymentMethod = ''} = res.data || {};
  return Promise.resolve(paymentMethod)
}